import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Button from '../Common/Button';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import './UserLocationsForm.scss';

export default class UserLocationsForm extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			selectedNewLocation: 0,
			selectedGrantedLocations: [],
			selectedAssignedLocations: [],
		};
	}

	renderAssignedLocations = () => {
		let options = [];
		this.props.assignedLocations.forEach(function (option) {
			options.push(
				<option key={option.id} value={option.id}>
					{option.name}
				</option>
			);
		});
		return options;
	};

	renderProfileRuleGrantedLocations = () => {
		let options = [];
		this.props.profileRuleGrantedLocations.forEach(function (option) {
			options.push(
				<option key={option.id} value={option.id}>
					{option.name}
				</option>
			);
		});
		return options;
	};

	selectNewLocation = (e) => {
		this.setState({ selectedNewLocation: e });
	};

	addNewLocation = (e) => {
		e.preventDefault();
		if (this.state.selectedNewLocation) {
			this.props.addLocation(this.state.selectedNewLocation);
			this.setState({ selectedNewLocation: null });
		}
		return false;
	};

	onSelectGrantedChange = (e) => {
		const location = this.props.profileRuleGrantedLocations.find((x) => x.id.toString() === e.target.value);
		this.setState({ selectedGrantedLocations: [location] });
	};

	onSelectAssignedChange = (e) => {
		const options = e.target.options;
		let selected = [];
		for (var i = 0; i < options.length; i++) {
			if (options[i].selected) {
				const value = options[i].value;
				const location = this.props.assignedLocations.find((x) => x.id.toString() === value);
				selected.push(location);
			}
		}
		this.setState({ selectedAssignedLocations: selected });
	};

	removeSelectedExistingLocation = () => {
		this.props.removeLocation(this.state.selectedAssignedLocations);
	};

	onChangeDefaultLocation = (csv) => {
		this.props.onDefaultLocationChange(csv);
	};

	render() {
		return (
			<div className='user-locations-access-form'>
				<h4>{this.props.user.firstName + ' ' + this.props.user.lastName}</h4>
				<div>
					<form noValidate className={this.props.isFormValid ? '' : 'was-validated'}>
						<div>
							<MultiSelectBox
								name='defaultLocation'
								label='Default Location'
								className='default-location-ddl'
								selectedValues={this.props.defaultLocationId.toString()}
								idField='id'
								valueField='name'
								defaultValue='Choose...'
								options={this.props.availableForDefaultLocations}
								onChange={this.onChangeDefaultLocation}
								isRequired={true}
								errorMessage='Default Location is Required'
								isMulti={false}
							/>
						</div>
					</form>
				</div>
				{(this.props.isUserGrantedAccessToAllLocations === true || this.props.isUserGrantedAccessToAllLocations === null) && (
					<div>
						<hr />
						<div className='row'>
							<div className='col'>
								<div className='alert alert-warning' role='alert'>
									Profile settings have granted access to all active locations in this subscription.
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col'>
								<span className='has-float-label'>
									<select
										id='profileRuleGrantedLocations'
										className='form-control mt-3'
										multiple
										size='8'
										onClick={this.onSelectGrantedChange}>
										{this.renderProfileRuleGrantedLocations()}
									</select>
									<label htmlFor='profileRuleGrantedLocations'>Access Granted by User Profile</label>
								</span>
							</div>
						</div>
					</div>
				)}

				{(this.props.isUserGrantedAccessToAllLocations === false || this.props.isUserGrantedAccessToAllLocations === null) && (
					<div>
						<hr />

						<div className='row search-field gap-2 d-flex justify-content-between'>
							<Select
								name='locations'
								placeholder='Search for a location to add...'
								options={this.props.availableForAssignmentLocations}
								onChange={this.selectNewLocation}
								value={this.state.selectedNewLocation}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
								className='col-7'
							/>

							{/* <button className="btn-icon col-1" onClick={this.addNewLocation}><i className="fa fa-plus-circle"></i></button> */}
							<button type='button' className='btn btn-primary col-1 btn-icon' onClick={this.addNewLocation} alt='close popup'>
								<i className='fa fa-plus-circle'></i>
							</button>
							<button className='btn btn-outline-secondary col-2' onClick={this.props.onBulkLocationSearchLaunch}>
								Bulk Add
							</button>
						</div>

						<div className='row'>
							<div className='col'>
								<span className='has-float-label'>
									<select
										id='baselineJobTitles'
										className='form-control mt-3'
										multiple
										size='8'
										defaultValue={[]}
										onChange={this.onSelectAssignedChange}>
										{this.renderAssignedLocations()}
									</select>
									<label htmlFor='baselineJobTitles'>Assigned Locations</label>
								</span>
								<div className='text-end'>
									<Button
										type='button'
										bootstrapClass='btn btn-outline-secondary mt-2'
										name='btnRemoveLocation'
										text='Remove Selected'
										onClick={this.removeSelectedExistingLocation}
									/>
								</div>
								<br />
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

UserLocationsForm.propTypes = {
	user: PropTypes.object.isRequired,
	assignedLocations: PropTypes.array.isRequired,
	availableForAssignmentLocations: PropTypes.array.isRequired,
	availableForDefaultLocations: PropTypes.array.isRequired,
	profileRuleGrantedLocations: PropTypes.array.isRequired,
	defaultLocationId: PropTypes.string.isRequired,
	isUserGrantedAccessToAllLocations: PropTypes.bool, // false = no, true = yes, null = based on rule
	addLocation: PropTypes.func.isRequired,
	removeLocation: PropTypes.func.isRequired,
	onDefaultLocationChange: PropTypes.func.isRequired,
	isFormValid: PropTypes.bool.isRequired,
	onBulkLocationSearchLaunch: PropTypes.func.isRequired,
};
